import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=40e1345c&scoped=true"
import script from "./ShareList.vue?vue&type=script&lang=js"
export * from "./ShareList.vue?vue&type=script&lang=js"
import style0 from "./ShareList.vue?vue&type=style&index=0&id=40e1345c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1345c",
  null
  
)

export default component.exports